import OtpForm from "../components/OtpForm";
import useDocumentTitle from "../../../shared/customHooks/useDocumentTitle";
import "../styles/mfa.css";

const MfaVerificationPage = ({message}) => {
  useDocumentTitle('MFA Verification')
  return (
    <>

      <div className="container text-center mt-4">

        {message && <p className="message">{message}</p>}

        <div className="qr-container">
          
            <h2 className="header-title">
              Enter the 6-Digit Code you see in your authenticator App
            </h2>
          
        </div>

        <OtpForm />
      </div>

    </>
  );
};

export default MfaVerificationPage;